import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-form dark-mode" }
const _hoisted_2 = { class: "field" }
const _hoisted_3 = { class: "control" }
const _hoisted_4 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_5 = { style: {"display":"flex","justify-content":"space-between","align-items":"center","margin-bottom":"1rem"} }
const _hoisted_6 = { class: "icon is-small" }
const _hoisted_7 = { class: "table-container" }
const _hoisted_8 = { class: "table is-fullwidth is-hoverable dark-table" }
const _hoisted_9 = { style: {"color":"#e5e7eb","border-color":"#4b5563"} }
const _hoisted_10 = {
  key: 0,
  class: "tag",
  style: {"background-color":"#2563eb","color":"white","border-radius":"4px","padding":"2px 8px"}
}
const _hoisted_11 = { style: {"border-color":"#4b5563"} }
const _hoisted_12 = { style: {"color":"#e5e7eb","border-color":"#4b5563"} }
const _hoisted_13 = { style: {"border-color":"#4b5563","padding-right":"0.5rem"} }
const _hoisted_14 = { style: {"display":"flex","align-items":"center","justify-content":"space-between"} }
const _hoisted_15 = { style: {"color":"#ffffff","text-align":"right","flex":"1","padding-right":"1rem"} }
const _hoisted_16 = {
  key: 1,
  class: "notification mt-4",
  style: {"background-color":"#374151","border":"1px solid #4b5563"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VButton = _resolveComponent("VButton")!
  const _component_VModal = _resolveComponent("VModal")!

  return (_openBlock(), _createBlock(_component_VModal, {
    open: _ctx.open,
    title: 'Contract Volumes Calculator',
    size: "medium",
    onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("label", {
            class: "label",
            style: {"color":"#9ca3af","display":"block","margin-bottom":"0.5rem"}
          }, "Key Contract Volume", -1)),
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keyProductVolume) = $event)),
              type: "number",
              class: "input",
              style: {"background-color":"#1f2937","border":"2px solid #374151","color":"#ffffff","width":"100%","padding":"0.625rem","font-size":"1rem","border-radius":"4px","display":"block"},
              placeholder: "Enter key Contract volume",
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.calculateVolumes && _ctx.calculateVolumes(...args)))
            }, null, 544), [
              [
                _vModelText,
                _ctx.keyProductVolume,
                void 0,
                { number: true }
              ]
            ])
          ])
        ]),
        (_ctx.calculatedVolumes.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[6] || (_cache[6] = _createElementVNode("h4", {
                  class: "subtitle is-5",
                  style: {"color":"#9ca3af","margin":"0"}
                }, "Calculated Contract Volumes", -1)),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyAllVolumes && _ctx.copyAllVolumes(...args))),
                  class: "button is-small",
                  style: _normalizeStyle([{"background-color":"#2563eb","color":"white","padding":"0.5rem 1rem"}, _ctx.copiedAll ? 'background-color: #10b981;' : ''])
                }, [
                  _createElementVNode("span", _hoisted_6, [
                    _createElementVNode("i", {
                      class: _normalizeClass(_ctx.copiedAll ? 'fas fa-check' : 'fas fa-copy')
                    }, null, 2)
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.copiedAll ? 'Copied!' : 'Copy All'), 1)
                ], 4)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("table", _hoisted_8, [
                  _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", { style: {"background-color":"#374151"} }, [
                      _createElementVNode("th", { style: {"color":"#9ca3af","border-color":"#4b5563"} }, "Contract"),
                      _createElementVNode("th", { style: {"color":"#9ca3af","border-color":"#4b5563"} }, "Type"),
                      _createElementVNode("th", { style: {"color":"#9ca3af","border-color":"#4b5563"} }, "Exe Ratio"),
                      _createElementVNode("th", { style: {"color":"#9ca3af","border-color":"#4b5563"} }, "Calculated Volume")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.calculatedVolumes, (item, index) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: index,
                        style: _normalizeStyle({
                      'background-color': item.transactionType === 'BUY' ? '#2563eb33' : '#dc262633'
                    })
                      }, [
                        _createElementVNode("td", _hoisted_9, [
                          (item.isKey)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_10, "KEY"))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(item.productName), 1)
                        ]),
                        _createElementVNode("td", _hoisted_11, [
                          _createElementVNode("span", {
                            class: "tag",
                            style: _normalizeStyle({
                      'background-color': item.transactionType === 'BUY' ? '#2563eb' : '#dc2626',
                      'color': 'white',
                      'border-radius': '4px',
                      'padding': '2px 8px'
                    })
                          }, _toDisplayString(item.transactionType), 5)
                        ]),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(item.exeRatio), 1),
                        _createElementVNode("td", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("strong", _hoisted_15, _toDisplayString(item.volume), 1)
                          ])
                        ])
                      ], 4))
                    }), 128))
                  ])
                ])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[8] || (_cache[8] = [
              _createElementVNode("p", { style: {"color":"#d1d5db"} }, "Enter a key product volume to calculate leg volumes based on exe ratios.", -1)
            ]))]))
      ])
    ]),
    cancel: _withCtx(() => [
      _createVNode(_component_VButton, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
          _createTextVNode(" Cancel ", -1)
        ]))]),
        _: 1
      })
    ]),
    action: _withCtx(() => [
      _createVNode(_component_VButton, {
        color: "primary",
        onClick: _ctx.applyVolumes,
        disabled: !_ctx.keyProductVolume || _ctx.keyProductVolume <= 0
      }, {
        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
          _createTextVNode(" Add to List ", -1)
        ]))]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    _: 1
  }, 8, ["open"]))
}